angular.module('impactx.purchaseorder').controller('PurchaseOrderSupplierAcceptCtrl', [
    '$scope',
    'dataGen',
    'AppConfiguration',
    'LegalLinking',
    'TranslationService',
    '$routeParams',
    PurchaseOrderSupplierAcceptCtrl]);

function PurchaseOrderSupplierAcceptCtrl($scope, dataGen, AppConfiguration, LegalLinking, TranslationService, $routeParams) {
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');
    $scope.translations = TranslationService;

    dataGen.getData($scope, {osutan: $routeParams.osutan}, "/purchaseorder/accept/supplier");

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };
}
